import React from "react";
import { MapPin, Flame, Cookie, Droplet } from "lucide-react";

const BEANS_IMG =
  "https://images.unsplash.com/photo-1762539401839-b8378f395cc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwcm9hc3RlZCUyMGNvZmZlZSUyMGJlYW5zJTIwbWFjcm8lMjBibGFjayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc4MDY5OTgwfDA&ixlib=rb-4.1.0&q=85";

const FACTS = [
  {
    icon: MapPin,
    label: "Origin",
    value: "Chikmagalur, India",
    copy: "Estate-grown at altitude. Hand-picked. Shade-harvested.",
  },
  {
    icon: Flame,
    label: "Roast",
    value: "Medium-Dark",
    copy: "Roasted slow for depth, without sacrificing complexity.",
  },
  {
    icon: Cookie,
    label: "Profile",
    value: "Chocolate, Nutty",
    copy: "Smooth tasting notes with a rounded, balanced finish.",
  },
  {
    icon: Droplet,
    label: "Acidity",
    value: "Low",
    copy: "Gentle on the stomach. Easy to drink black or with milk.",
  },
];

export default function Credibility() {
  return (
    <section
      id="credibility"
      data-testid="credibility-section"
      className="relative py-24 md:py-36 bg-[color:var(--fs-surface)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-6">
            <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
              03 / Coffee Credibility
            </span>
            <h2
              className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white"
              data-testid="credibility-heading"
            >
              Built on
              <br />
              <span className="italic text-gold-foil">
                Exceptional Coffee.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-neutral-400 text-base leading-relaxed max-w-md">
              This is a coffee-first experience. Before anything else — it has
              to taste incredible, brew clean, and feel refined in the cup.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Feature image card */}
          <div
            className="lg:col-span-5 relative aspect-[4/5] overflow-hidden rounded-[2px] border border-[color:var(--fs-hairline)]"
            data-testid="credibility-image"
          >
            <img
              src={BEANS_IMG}
              alt="Dark roasted coffee beans"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
                Lot 001
              </div>
              <div className="mt-2 font-display text-3xl text-white italic">
                Chikmagalur Reserve
              </div>
            </div>
          </div>

          {/* Facts bento */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {FACTS.map((f) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.label}
                  className="card-gold p-8 rounded-[2px] flex flex-col gap-4"
                  data-testid={`credibility-fact-${f.label.toLowerCase()}`}
                >
                  <Icon
                    size={22}
                    strokeWidth={1.4}
                    className="text-[color:var(--fs-gold-muted)]"
                  />
                  <div>
                    <div className="text-[10px] tracking-[0.32em] uppercase text-neutral-500">
                      {f.label}
                    </div>
                    <div className="mt-1 font-display text-2xl text-white">
                      {f.value}
                    </div>
                  </div>
                  <p className="text-sm text-neutral-400 leading-relaxed">
                    {f.copy}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
